export default {
      id: "ic_notice-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_notice",
      toString: function () {
        return this.url;
      }
    }